<template>
  <UIModal
    v-model="isOpen"
    fix-header
    :index-override="100000"
    transparent
    :fullscreen="false"
    :disable-full-height="true"
    :header-top-offset="mobile ? 65 : undefined"
  >
    <div class="seasons-modal__badge">
      <img src="/img/christmas-badge.png" />
      <span class="seasons-modal__badge-text">{{ type === 'seasons' ? $t('seasons') : $t('jackpots') }}</span>
    </div>
    <div class="seasons-modal">
      <img
        :src="
          mobile
            ? '/img/seasons-mobile-info-bg.png'
            : type === 'seasons'
              ? '/img/seasons-prize-info.png'
              : '/img/seasons-jackpot-prize-info.png'
        "
        class="seasons-modal__hero"
      />
      <img src="/img/seasons-50k-badge.png" class="seasons-modal__money-badge" />
      <div
        :class="[
          'seasons-modal__text',
          { 'seasons-modal__text--left': type === 'jackpot' && !mobile, 'seasons-modal__text--mobile': mobile }
        ]"
      >
        <template v-if="type === 'seasons'">
          <p>{{ $t('seasonPrizeInfoText1') }}</p>
          <p>&nbsp;</p>
          <p>{{ $t('seasonPrizeInfoText2') }}</p>
        </template>
        <template v-else>
          <p>{{ $t('jackpotPrizeInfoText1') }}</p>
          <p>&nbsp;</p>
          <p>{{ $t('jackpotPrizeInfoText2') }}</p>
        </template>
      </div>
    </div>
  </UIModal>
</template>

<script lang="ts" setup>
type PrizeType = 'seasons' | 'jackpot';

const isOpen = defineModel<boolean>({ default: false });

withDefaults(
  defineProps<{
    type?: PrizeType;
    mobile?: boolean;
  }>(),
  {
    type: 'seasons',
    mobile: false
  }
);
</script>

<style lang="scss" scoped>
.seasons-modal {
  position: relative;
  max-width: 639px;
  width: 100%;
  padding-top: 50px;

  @media (min-width: 640px) {
    padding-top: 0;
  }

  &__badge {
    position: absolute;
    z-index: 1;
    top: -40px;
    width: 400px;
    max-width: calc(100% - 32px);
    left: 50%;
    transform: translateX(-50%);

    @media (max-width: 639px) {
      top: 6px;
      width: min(400px, calc(100% - 32px));
    }

    img {
      width: 100%;
      height: auto;
      display: block;
    }
  }

  &__badge-text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) translateY(-6px);
    white-space: nowrap;
    z-index: 2;

    font-weight: 700;
    font-size: 32px;
    line-height: 100%;
    color: #fff;
    text-shadow:
      1px 1px 0 #000,
      -1px -1px 0 #000,
      1px -1px 0 #000,
      -1px 1px 0 #000,
      0px 1px 0 #000,
      0px -1px 0 #000,
      1px 0px 0 #000,
      -1px 0px 0 #000;

    filter: drop-shadow(0px 2px 0px #000);

    @media (max-width: 639px) {
      font-size: 24px;
    }
  }

  &__hero {
    width: 100%;
    border-radius: 12px 12px 0 0;
    display: block;

    @media (max-width: 639px) {
      border-radius: 0;
    }
  }

  &__money-badge {
    position: absolute;
    z-index: 100;
    top: 8px;
    left: 50%;
    transform: translateX(-50%);
    pointer-events: none;

    @media (max-width: 639px) {
      top: 50px;
    }
  }

  &__text {
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    color: #fff;
    font-weight: 400;
    font-size: 16px;
    line-height: 140%;
    text-align: center;
    max-width: 300px;
    pointer-events: none;

    p {
      margin: 0;
      padding: 0;
    }

    &--left {
      right: auto;
      left: 20px;
    }

    &--mobile {
      width: calc(100% - 40px);
      left: 20px;
      right: 20px;
      text-align: center;
      max-width: none;
      margin-top: 30px;
    }
  }
}
</style>
